/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Property_TypeInputs */

const en_field_property_type = /** @type {(inputs: Field_Property_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Property Type`)
};

const es_field_property_type = /** @type {(inputs: Field_Property_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de propiedad`)
};

const fr_field_property_type = /** @type {(inputs: Field_Property_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type de propriété`)
};

const de_field_property_type = /** @type {(inputs: Field_Property_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Immobilientyp`)
};

const ja_field_property_type = /** @type {(inputs: Field_Property_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不動産のタイプ`)
};

const zh_field_property_type = /** @type {(inputs: Field_Property_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`房产类型`)
};

const ar_field_property_type = /** @type {(inputs: Field_Property_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نوع العقار`)
};

const id_field_property_type = /** @type {(inputs: Field_Property_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenis Properti`)
};

const it_field_property_type = /** @type {(inputs: Field_Property_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo di Proprietà`)
};

const ru_field_property_type = /** @type {(inputs: Field_Property_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип недвижимости`)
};

const pt_field_property_type = /** @type {(inputs: Field_Property_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de Propriedade`)
};

const ko_field_property_type = /** @type {(inputs: Field_Property_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`부동산 유형`)
};

/**
* | output |
* | --- |
* | "Property Type" |
*
* @param {Field_Property_TypeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_property_type = /** @type {((inputs?: Field_Property_TypeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Property_TypeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_property_type(inputs)
	if (locale === "es") return es_field_property_type(inputs)
	if (locale === "fr") return fr_field_property_type(inputs)
	if (locale === "de") return de_field_property_type(inputs)
	if (locale === "ja") return ja_field_property_type(inputs)
	if (locale === "zh") return zh_field_property_type(inputs)
	if (locale === "ar") return ar_field_property_type(inputs)
	if (locale === "id") return id_field_property_type(inputs)
	if (locale === "it") return it_field_property_type(inputs)
	if (locale === "ru") return ru_field_property_type(inputs)
	if (locale === "pt") return pt_field_property_type(inputs)
	return ko_field_property_type(inputs)
});